"use client";

import { LocalePillToggle } from "@/components/LocaleSwitcher/LocalePillToggle";
import { HeaderLanguageToggleFeature } from "@/components/LocaleSwitcher/HeaderLanguageToggleFeature";
import { cn } from "@/lib/utils";

type HeaderLanguageToggleProps = {
  className?: string;
};

export default function HeaderLanguageToggle({
  className,
}: HeaderLanguageToggleProps) {
  return (
    <HeaderLanguageToggleFeature>
      <LocalePillToggle
        className={cn(className)}
        data-testid="header-language-toggle"
      />
    </HeaderLanguageToggleFeature>
  );
}
